import { render } from "./initials_step.vue?vue&type=template&id=756222be"
import script from "./initials_step.vue?vue&type=script&lang=js"
export * from "./initials_step.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"app/javascript/submission_form/initials_step.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "756222be"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('756222be', __exports__)) {
    api.reload('756222be', __exports__)
  }
  
  module.hot.accept("./initials_step.vue?vue&type=template&id=756222be", () => {
    api.rerender('756222be', render)
  })

}


export default __exports__